// Müşteri Aktarımı (Excel) penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'sales.customerImport';

export const customerImportGuide = (t: TFunction): GuideContent => ({
  layout: 'tabbed',
  title: t(`${G}.title`, 'Excel\'den müşteri nasıl aktarılır?'),
  intro: t(`${G}.intro`, 'Elinizdeki müşteri listesini telefon ve adresleriyle birlikte tek seferde sisteme yüklersiniz. Pencere üç adımdır: dosya ve eşleştirme, önizleme, aktarım. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık ve adım'),
    tabs: t(`${G}.regions.tabs`, 'Adımlar'),
    body: t(`${G}.regions.body`, 'Dosya ve eşleştirme'),
    footer: t(`${G}.regions.footer`, 'Önizle / İşle'),
  },
  navItems: [
    t(`${G}.nav.file`, '1. Dosya'),
    t(`${G}.nav.preview`, '2. Önizleme'),
    t(`${G}.nav.import`, '3. Aktarım'),
  ],
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Dosyayı ve sayfayı seçin'),
      text: t(`${G}.s1.text`, '"Excel Dosyası Yükle" alanına tıklayıp .xls, .xlsx veya .csv dosyanızı seçin. Dosyada birden çok sayfa varsa "Sayfa" listesinden doğru sayfayı seçin.'),
      tips: [
        t(`${G}.s1.tip1`, '"Başlangıç Satırı (başlık hariç)": verinin başladığı satırı yazın; üstteki boş veya açıklama satırlarını atlar.'),
        t(`${G}.s1.tip2`, 'Başlıktaki "Adım 1/3" hangi adımda olduğunuzu gösterir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Şube ve cari grubu seçin'),
      text: t(`${G}.s2.text`, '"Şube Seçimi" ve "Cari Grup Seçimi" zorunludur. Aktarılan müşteriler seçtiğiniz şubeye ve cari gruba kaydedilir.'),
      tips: [
        t(`${G}.s2.tip1`, 'Paket ekranından eklenen müşteriler "Paket Müşterisi" grubunda tutulur; aynı grubu seçerseniz bütün paket müşterileriniz bir arada olur.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Sütunları eşleştirin'),
      text: t(`${G}.s3.text`, '"Sütun Eşleştirme" bölümünde her alan için Excel\'deki sütunu seçin. Başlığı benzeyen sütunlar kendiliğinden eşleşir; yine de kontrol edin. Kullanmadığınız alanı "(Eşleştirme yok)" bırakın.'),
      tips: [
        t(`${G}.s3.tip1`, 'Yalnız "Müşteri Adı" zorunludur. Telefon 1, Telefon 2, Firma Adı, Şehir, İlçe / Semt, Mahalle, Cadde, Sokak, Apartman, Site Adı, Blok, Bina No, Kat, Daire No, Açık Adres ve Bölge isteğe bağlıdır.'),
        t(`${G}.s3.tip2`, '"Önizle" düğmesi dosya, şube, cari grup ve Müşteri Adı eşleşmesi tamamlanınca açılır.'),
      ],
    },
    {
      region: 'tabs',
      title: t(`${G}.s4.title`, '4. Önizlemeyi ve mevcut kayıtları kontrol edin'),
      text: t(`${G}.s4.text`, 'Önizlemede telefon numaraları sistemde aranır. Üstteki etiketler Toplam, Telefonlu, Telefonsuz, Tekrarlı Tel, İsimsiz, Mevcut ve Yeni sayılarını gösterir; tabloda her satır "Yeni" ya da "Güncelle" olarak işaretlenir.'),
      tips: [
        t(`${G}.s4.tip1`, 'Telefonu sistemde kayıtlı müşteri yeniden oluşturulmaz; yalnız boş olan ad, firma adı ve telefon 2 bilgileri Excel\'den doldurulur. Bilgisi tam olanlar atlanır.'),
        t(`${G}.s4.tip2`, 'Kayıtlı müşterinin farklı bir adresi varsa yeni adres olarak eklenir; aynı adres atlanır.'),
        t(`${G}.s4.tip3`, 'Ad, Telefon 1 ve Telefon 2 alanlarının üçü de boş olan satırlar alınmaz.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Aktarımı başlatın'),
      text: t(`${G}.s5.text`, '"… Satırı İşle" düğmesine basın. Kayıtlar 100\'erli paketler halinde gönderilir ve ilerleme çubuğu dolar. Bitince Toplam Satır, Başarılı, Yeni Müşteri, Yeni Adres ve Güncellenen sayıları ile hatalı satırların listesi görünür.'),
      tips: [
        t(`${G}.s5.tip1`, '"Aktarımı Durdur": o anki paket bitince durur. O ana kadar kaydedilenler sistemde kalır.'),
        t(`${G}.s5.tip2`, '"Detaylı İşlem Logları" her paketin sonucunu ve hata nedenlerini gösterir.'),
        t(`${G}.s5.tip3`, '"Geri" ile 1. adıma dönüp eşleştirmeyi düzeltebilirsiniz. Başlıktaki (i) bu rehberi açar.'),
      ],
    },
  ],
});
